var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-trash-2908521",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.042,
    height: 14.704,
    viewBox: "0 0 13.042 14.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #434343;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    className: "cls-1",
    d: "M193.441,126.792h-8.557L183.75,113.75h10.831Zm-8.035-.567h7.508l1.015-11.908h-9.583Z",
    transform: "translate(-182.616 -112.089)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    className: "cls-1",
    d: "M161.509,114.317H149.034a.284.284,0,1,1,0-.567h12.475a.284.284,0,0,1,0,.567Z",
    transform: "translate(-148.75 -112.089)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    className: "cls-1",
    d: "M277.979,64.705H273v-.811a1.417,1.417,0,0,1,1.418-1.418h2.143a1.417,1.417,0,0,1,1.418,1.418Zm-4.412-.567h3.845v-.244a.856.856,0,0,0-.851-.851h-2.143a.851.851,0,0,0-.851.851Z",
    transform: "translate(-268.974 -62.477)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    "data-name": "Path 3476",
    className: "cls-1",
    d: "M341.354,184.27a.3.3,0,0,1,.284.284v7.922a.284.284,0,0,1-.284.284.3.3,0,0,1-.284-.284v-7.922A.284.284,0,0,1,341.354,184.27Z",
    transform: "translate(-334.838 -180.324)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    className: "cls-1",
    d: "M273.284,184.27a.3.3,0,0,1,.284.284v7.922a.284.284,0,0,1-.284.284.3.3,0,0,1-.284-.284v-7.922A.284.284,0,0,1,273.284,184.27Z",
    transform: "translate(-268.974 -180.324)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    "data-name": "Path 3478",
    className: "cls-1",
    d: "M409.434,184.27a.3.3,0,0,1,.283.284v7.922a.284.284,0,0,1-.283.284.3.3,0,0,1-.284-.284v-7.922A.284.284,0,0,1,409.434,184.27Z",
    transform: "translate(-400.712 -180.324)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5b8a8ba7d2dc8bbb8efd4891ca3b6341.svg";
export { ForwardRef as ReactComponent };